import * as QuizDataApi from '../api/quizlerApi';

export const RECEIVE_RESULTS = 'RECEIVE_RESULTS';
export const RESULTS_LOADING = 'RESULTS_LOADING';

const receiveResults = (results) => ({
    type: RECEIVE_RESULTS,
    results
});

export const resultsLoading = () => ({
    type: RESULTS_LOADING
});

export const fetchResults = (indexName) => dispatch => {
    dispatch(resultsLoading());

    return QuizDataApi.fetchResults(indexName)
        .then(res => {
            const results = res.data.filter(result => result.filters); //exclude all results without filters
            return dispatch(receiveResults(results));
        })
};